import { TextStrikethroughIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const LineThrough = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <TextStrikethroughIcon size={Sizes[size]} {...rest} color={fill} />;
};
